import { render, staticRenderFns } from "./resourceAction.vue?vue&type=template&id=06732db6&"
import script from "./resourceAction.vue?vue&type=script&lang=js&"
export * from "./resourceAction.vue?vue&type=script&lang=js&"
import style0 from "./resourceAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports